import type { SxProps, Theme } from '@mui/material/styles'

/** Matches CompactButton dense height (32px). */
export const compactSelectSx: SxProps<Theme> = {
    height: 32,
    boxSizing: 'border-box',
    fontSize: '0.8125rem',
    '& .MuiSelect-select': {
        py: 0,
        display: 'flex',
        alignItems: 'center',
    },
}
